import React, { useEffect, useState } from 'react';
import './atom.css';
import Modal from 'react-modal';
import CircularProgress from '@mui/material/CircularProgress';
import { updateQRStatus } from '../services/asset.service';
import * as CryptoJS from "crypto-js";

Modal.setAppElement('#root');

const StickerPasteStatusPopupBox = ({ qrPasteStatus, tag, isOpen, onClose }) => {
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const [qrPasteStatusPop, setQRPasteStatus] = useState(qrPasteStatus || 'N');
    const [ErrQRPasteStatus, setErrQRPasteStatus] = useState('');

    useEffect(() => {
        if (isOpen) {
            setQRPasteStatus(qrPasteStatus || 'N');
            setErrMsg('');
            setSuccess('');
            setErrQRPasteStatus('');
        }
    }, [qrPasteStatus, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!qrPasteStatusPop) {
            setErrQRPasteStatus('Please select QR Paste Status');
            return;
        }
        setErrQRPasteStatus('');
        updateData();
    };

    const updateData = async function () {
        setSuccess('');
        setErrMsg('');
        setLoading(true);

        let obj = {
            'tag': tag,
            'qr_paste_status': qrPasteStatusPop,
            'created_by': sessionStorage.getItem('LoggedInUserId')
        };

        let EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        let oData = { 'token': EncryptData };

        try {
            const res = await updateQRStatus(oData);
            if (res?.data?.errors?.errno > 0) {
                setErrMsg(res.data.message || 'Update failed');
                setSuccess('');
            } else {
                setSuccess(res?.data?.message || 'Status successfully updated!');
            }
        } catch (err) {
            console.error("Error updating QR status:", err);
            setSuccess('');
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 409) {
                setErrMsg('Data conflict occurred');
            } else {
                setErrMsg('Failed to update QR status');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleGrouping = (e) => {
        setQRPasteStatus(e.target.value);
        if (ErrQRPasteStatus) setErrQRPasteStatus('');
    };

    const isCurrentPasted = qrPasteStatus !== 'N';

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Update Status of QR Label Pasting"
            style={customModalStyles}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#ffffff',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    fontFamily: 'inherit'
                }}
            >
                {/* Modal Header */}
                <div
                    style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                        padding: '16px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        color: '#ffffff',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div
                            style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '8px',
                                background: 'rgba(56, 189, 248, 0.15)',
                                border: '1px solid rgba(56, 189, 248, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#38bdf8',
                                fontSize: '18px'
                            }}
                        >
                            <i className="bi bi-qr-code-scan"></i>
                        </div>
                        <div>
                            <h5 style={{ margin: 0, fontWeight: 700, fontSize: '17px', color: '#ffffff' }}>
                                Update QR Label Pasting Status
                            </h5>
                            <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#94a3b8' }}>
                                Modify stickering status for tag sticker tracking
                            </p>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            color: '#cbd5e1',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '18px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'; e.currentTarget.style.color = '#ffffff'; }}
                        onMouseOut={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'; e.currentTarget.style.color = '#cbd5e1'; }}
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Body */}
                <div style={{ padding: '24px' }}>
                    {/* Asset Summary Info Card */}
                    <div
                        style={{
                            background: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '12px',
                            padding: '14px 18px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="bi bi-tag-fill text-primary" style={{ fontSize: '16px' }}></i>
                            <span style={{ fontSize: '13px', color: '#64748b', fontWeight: 500 }}>TAG Number:</span>
                            <span style={{ fontSize: '14px', color: '#0f172a', fontWeight: 700, fontFamily: 'monospace' }}>
                                {tag || 'N/A'}
                            </span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>Current Status:</span>
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '3px 10px',
                                    borderRadius: '12px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    background: isCurrentPasted ? '#dcfce7' : '#fee2e2',
                                    color: isCurrentPasted ? '#15803d' : '#b91c1c',
                                    border: isCurrentPasted ? '1px solid #bbf7d0' : '1px solid #fecaca'
                                }}
                            >
                                <i className={`bi ${isCurrentPasted ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                                {isCurrentPasted ? 'Pasted' : 'Not Pasted'}
                            </span>
                        </div>
                    </div>

                    {/* Feedback Alerts */}
                    {success && (
                        <div
                            style={{
                                background: '#f0fdf4',
                                border: '1px solid #bbf7d0',
                                color: '#166534',
                                padding: '12px 16px',
                                borderRadius: '10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <i className="bi bi-check-circle-fill" style={{ fontSize: '16px', color: '#16a34a' }}></i>
                            <span>{success}</span>
                        </div>
                    )}

                    {errMsg && (
                        <div
                            style={{
                                background: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#991b1b',
                                padding: '12px 16px',
                                borderRadius: '10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '16px', color: '#dc2626' }}></i>
                            <span>{errMsg}</span>
                        </div>
                    )}

                    {/* Update Form */}
                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '20px' }}>
                            <label
                                style={{
                                    display: 'block',
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#334155',
                                    marginBottom: '8px'
                                }}
                            >
                                QR Label Pasting Status <span style={{ color: '#ef4444' }}>*</span>
                            </label>

                            <select
                                value={qrPasteStatusPop}
                                onChange={handleGrouping}
                                style={{
                                    width: '100%',
                                    padding: '10px 14px',
                                    fontSize: '14px',
                                    borderRadius: '10px',
                                    border: ErrQRPasteStatus ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    background: '#ffffff',
                                    color: '#0f172a',
                                    outline: 'none',
                                    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                                }}
                            >
                                <option value="Y">Pasted (Y)</option>
                                <option value="N">Not Pasted (N)</option>
                            </select>

                            {ErrQRPasteStatus && (
                                <span style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px', display: 'block', fontWeight: 500 }}>
                                    {ErrQRPasteStatus}
                                </span>
                            )}
                        </div>

                        {/* Modal Actions */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                gap: '12px',
                                marginTop: '24px'
                            }}
                        >
                            <button
                                type="button"
                                onClick={onClose}
                                style={{
                                    background: '#f1f5f9',
                                    color: '#475569',
                                    border: '1px solid #cbd5e1',
                                    padding: '9px 20px',
                                    borderRadius: '10px',
                                    fontWeight: 600,
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s ease-in-out'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#e2e8f0'}
                                onMouseOut={(e) => e.currentTarget.style.background = '#f1f5f9'}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                                    color: '#ffffff',
                                    border: 'none',
                                    padding: '9px 22px',
                                    borderRadius: '10px',
                                    fontWeight: 600,
                                    fontSize: '13px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    boxShadow: '0 2px 4px rgba(2, 132, 199, 0.25)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    opacity: loading ? 0.7 : 1,
                                    transition: 'all 0.15s ease-in-out'
                                }}
                                onMouseOver={(e) => { if (!loading) e.currentTarget.style.opacity = '0.9'; }}
                                onMouseOut={(e) => { if (!loading) e.currentTarget.style.opacity = '1'; }}
                            >
                                {loading ? (
                                    <>
                                        <CircularProgress size={16} style={{ color: '#ffffff' }} />
                                        <span>Updating...</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check2-circle"></i>
                                        <span>Update Status</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(6px)',
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px'
    },
    content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        maxWidth: '520px',
        padding: 0,
        border: '1px solid rgba(226, 232, 240, 0.8)',
        borderRadius: '16px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.35)',
        overflow: 'hidden',
        inset: 'auto'
    }
};

export default StickerPasteStatusPopupBox;